// @flow
import * as EmailValidator from 'email-validator/index';

const ValidateEmail = (value) => {
  if (!value) {
    return 'Email is required';
  }

  if (!EmailValidator.validate(value)) {
    return 'Input is not an email';
  }

  if (value.length > 96) {
    return 'Email is too long.';
  }

  return null;
};

export default ValidateEmail;



// WEBPACK FOOTER //
// ./src/components/validation/rules/email.js